import React, { ReactElement, ReactNode, useCallback } from 'react';
import * as Styled from './styles';

interface QuestionProps {
  activeId: string;
  id: string;
  title: string;
  description: string | ReactNode;
  onChange: (id: string) => void;
}

export const Question = ({ activeId, description, id, title, onChange }: QuestionProps): ReactElement => {
  const isActive = activeId === id;

  const handleChange = useCallback(() => {
    onChange(id);
  }, [activeId, id]);

  return (
    <Styled.Question key={id}>
      <Styled.QuestionTitle onClick={handleChange}>
        {title}
        <Styled.IconDropdown isactive={isActive.toString()} />
      </Styled.QuestionTitle>
      {isActive && <Styled.QuestionDescription>{description}</Styled.QuestionDescription>}
    </Styled.Question>
  );
};
